import { Badge } from './ui/badge';
import { cn } from '../lib/utils';
import { getPlanContext, getPlanBadgeClasses } from '../lib/planContext';

/**
 * The ONE component to display a user's plan/owner status anywhere in the UI.
 * Never read `user.plan` directly in JSX — always go through this.
 *
 * Examples:
 *   <PlanBadge user={user} />                 // "Platform Owner" / "Enterprise" / etc.
 *   <PlanBadge user={user} short />           // "Owner" / "Enterprise" / "Growth" / "Starter"
 *   <PlanBadge user={user} className="..." /> // merge extra classes
 */
export const PlanBadge = ({ user, short = false, className }) => {
  const ctx = getPlanContext(user);
  return (
    <Badge
      className={cn('text-[10px] capitalize border', getPlanBadgeClasses(user), className)}
      data-testid="plan-badge"
      data-plan-tone={ctx.tone}
    >
      {short ? ctx.shortLabel : ctx.label}
    </Badge>
  );
};

export default PlanBadge;
